import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { ReportService } from '@shared/services';
import { MessagesActions, selectFeatureFlagEnabledByKey } from '@shared/store';
import { InsightDocumentActions } from '@shared/store/insight-document-store/insight-document.actions';
import { ErrorUtils } from '@shared/utils';

@Injectable()
export class InsightDocumentEffects {
  constructor(
    private actions$: Actions,
    private reportService: ReportService,
    private store: Store,
  ) {}

  loadInsightDocumentHistory$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InsightDocumentActions.loadInsightDocumentHistory),
      switchMap(() => {
        return this.reportService.getInsightReportStatus().pipe(
          map((insightDocuments) =>
            InsightDocumentActions.getInsightDocumentHistorySuccess({
              insightUnreadDocuments: insightDocuments?.filter((insightDocument) => !insightDocument.isChecked),
            }),
          ),
          catchError((error) => {
            return of(InsightDocumentActions.getInsightDocumentHistoryError({ error }));
          }),
        );
      }),
    );
  });

  getInsightDocumentHistoryFailure$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InsightDocumentActions.getInsightDocumentHistoryError),
      concatLatestFrom(() => this.store.select(selectFeatureFlagEnabledByKey('suppress-disabled-features-errors'))),
      tap({
        next: ([loadHistoryError, shouldSuppress]) => {
          if (!shouldSuppress) {
            ErrorUtils.catchError('reportService.getInsightReportStatus error', loadHistoryError.error);
          }
        },
      }),
      switchMap(([, shouldSuppress]) =>
        shouldSuppress ? EMPTY : of(MessagesActions.displayError({ message: 'Unable to fetch insight document history.' })),
      ),
    );
  });
}
